import { render, staticRenderFns } from "./act-order.vue?vue&type=template&id=1220debc&scoped=true&"
import script from "./act-order.vue?vue&type=script&lang=js&"
export * from "./act-order.vue?vue&type=script&lang=js&"
import style0 from "./act-order.vue?vue&type=style&index=0&id=1220debc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1220debc",
  null
  
)

export default component.exports